import React from 'react';
import ReactDOM from 'react-dom';
import Checklist from "./Checklist";

const fields = document.getElementsByTagName('input');
const checklistRegex = new RegExp(/\[checklist\]/);
let points;
let pointsFieldName;

for (let i in fields) {
  if (checklistRegex.test(fields[i].name)) {
    points = fields[i].value;
    pointsFieldName = fields[i].name;
  }
}
if (points !== '') {
  points = JSON.parse(points);
} else {
  points = null;
}
ReactDOM.render(
  <Checklist points={points} pointsFieldName={pointsFieldName} />,
  document.getElementById('checklist-app')
);
